import { notification } from 'antd';
import i18n from 'app/config/i18Config/i18n';
import { uniqueId } from 'lodash';
import { ReactNode } from 'react';
import { Button } from 'shared/ui/Button';
import { notificationDuration, notificationPlacement } from '../utils/constants';

type NotificationType = 'info' | 'warning' | 'error';

interface NotificationData {
  key: string;
  message: string;
  description: string | string[];
  type: NotificationType;
}

const notificationsStack: NotificationData[] = [];

export const showNotification = (type: NotificationType, message: string, description: string | string[]): void => {
  const key = uniqueId(type);
  notificationsStack.push({ key, message, description, type });

  const closeAll = (): void => {
    notification.destroy();
    notificationsStack.length = 0;
  };

  const renderNotifications = (): void => {
    notification.destroy();

    notificationsStack.forEach((notif, index) => {
      const isLast = index === notificationsStack.length - 1;
      const showCloseButton = notificationsStack.length > 1 && isLast;

      const renderDescription: ReactNode = (
        <>
          {Array.isArray(notif.description) ? notif.description.map((d, i) => <div key={i}>{d}</div>) : notif.description}

          {showCloseButton && (
            <Button onClick={closeAll} theme="clear" fontColor="text-error" fontSize="large" className="!underline mt-2">
              {i18n.t('Clear All', { ns: 'common' })}
            </Button>
          )}
        </>
      );

      notification.open({
        type: notif.type,
        key: notif.key,
        message: notif.message,
        description: renderDescription,
        placement: notificationPlacement,
        duration: notif.type === 'warning' ? null : notificationDuration,
        onClose: () => {
          const index = notificationsStack.findIndex((n) => n.key === notif.key);
          if (index !== -1) {
            notificationsStack.splice(index, 1);
          }
          renderNotifications();
        },
      });
    });
  };

  renderNotifications();
};
